export { CarouselMedium } from './carousel-medium'
